import styled from "styled-components";

export const GameItemTitleDefaultBox = styled.div`
    margin-bottom: 0.5rem;
    width: 15rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 1.3rem;
    ${({theme}) => theme.font.presets.regular};
    color: ${({theme}) => theme.colors.textLight};
`;